import { Component, Inject } from '@angular/core';
import { RegistrationReportComponent } from '../registration-report/registration-report.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-issue-seller-registration-report-component',
  standalone: false,
  templateUrl: './issue-seller-registration-report-component.component.html',
  styleUrl: './issue-seller-registration-report-component.component.scss'
})
export class IssueSellerRegistrationReportComponentComponent {
  isLoading: boolean = false;
  type: any;
  start_date = '';
  end_date = '';
  rep_name = '';
  off_rep_name = '';
  issue_cat = '';
  issue_date = '';
  newindetails: boolean = false;
  indetail: boolean = false;
  brfly: boolean = false;
  verybrfly: boolean = false;
  datewise: boolean = false;
  officerep: boolean = false;
  inDetailsRegReport = [];
  inDetailsRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  inDetailsOffRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };

   constructor(
      private dialogref: MatDialogRef<IssueSellerRegistrationReportComponentComponent>,
      private datePipe: DatePipe,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService
    ) {}
    newissuedatepp:any
    ngOnInit(): void {
      this.type = this.data['type'];
      this.start_date = this.data['start_date'];
      this.end_date = this.data['end_date'];
      this.rep_name = this.data['rep_name'];
      this.off_rep_name = this.data['off_rep_name'];
      this.newissuedatepp = this.data['newissuedatepp'];
    
      this.issue_cat = this.data['issue_cat'] === undefined ? "ALL" : this.data['issue_cat'];
    
      // Extract only the date part (before first comma)
      const issueDateRaw = this.data['issueDates'];
      if (Array.isArray(issueDateRaw) && issueDateRaw.length > 0) {
        this.issue_date = issueDateRaw[0].split(',')[0];
      } else {
        this.issue_date = "ALL";
      }
    
      console.log("Final Payload Data:", {
        representativeId: this.rep_name,
        startDate: this.start_date,
        endDate: this.end_date,
        officeRepresentativeId: this.off_rep_name,
        issueNameId: this.issue_cat,
        issueSellerDate: this.issue_date
      });
    
      this.getRegReportData();
    }
    filteredinDetailsRegReport:any
    showindetail: boolean = false;
    totalAmounts = {
      total_amount: 0,
      net_amount: 0,
      without_gst_amount: 0,
      issue_selling_amount: 0,
      issue_selling_discount_amt: 0,
      with_gst_amount: 0,
      issue_seller_price:0,
      gst_amount:0,
      issue_seller_copies:0,
      rcvamount: 0

    };
    categoryNameForHTML:any
    issueNameForHTML:any
    getRegReportData() {
      const issuesellerbooking = {
        "representativeId":this.rep_name,
        "startDate":this.start_date,
        "endDate":this.end_date,
        "officeRepresentativeId":this.off_rep_name,
        "issueNameId":this.issue_cat,
        "issueSellerDate": this.issue_date
      }
      this.service.getIssueSellerRegDetailsReportList(issuesellerbooking).subscribe((data) => {
        this.filteredinDetailsRegReport = data;
        this.categoryNameForHTML=this.filteredinDetailsRegReport[0].issue_category_id
        this.issueNameForHTML=this.filteredinDetailsRegReport[0].issue_name_id
        console.log(this.filteredinDetailsRegReport);
        // this.addFilters();
        this.filteredinDetailsRegReport.forEach((item: {
          entry_amt: string; issue_selling_amount: string; issue_seller_price: string; net_amount: string; without_gst_amount: string; issue_selling_discount_amt: string; with_gst_amount: string; issue_copies: string; 
}) => {
          this.totalAmounts.total_amount += item.issue_selling_amount ? parseFloat(item.issue_selling_amount) : 0;
          this.totalAmounts.issue_seller_price += item.issue_seller_price ? parseFloat(item.issue_seller_price) : 0;
          this.totalAmounts.net_amount += item.net_amount ? parseFloat(item.net_amount) : 0;
          this.totalAmounts.without_gst_amount += item.without_gst_amount ? parseFloat(item.without_gst_amount) : 0;
          this.totalAmounts.issue_selling_amount += item.issue_selling_amount ? parseFloat(item.issue_selling_amount) : 0;
          this.totalAmounts.issue_selling_discount_amt += item.issue_selling_discount_amt ? parseFloat(item.issue_selling_discount_amt) : 0;
          this.totalAmounts.with_gst_amount += item.with_gst_amount ? parseFloat(item.with_gst_amount) : 0;
          this.totalAmounts.issue_seller_copies += item.issue_copies ? parseFloat(item.issue_copies) : 0;
         this.totalAmounts.rcvamount += item.entry_amt ? parseFloat(item.entry_amt) : 0;
          let gstAmt = (item.with_gst_amount ? parseFloat(item.with_gst_amount) : 0) - (item.without_gst_amount ? parseFloat(item.without_gst_amount) : 0)
          this.totalAmounts.gst_amount += gstAmt;

        });
  
      });
    }

    
      exportExcel(fileName) {
        /* table id is passed over here */
        let element = document.getElementById('print-section');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        /* save to file */
        XLSX.writeFile(wb, fileName + '.xlsx');
      }
      print() {
        const originalTitle = document.title; // Store original title
        document.title = '';     // Set custom print title
      
        // Create a style tag for print-specific styles
        const style = document.createElement('style');
        style.innerHTML = `
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
              body {
          margin-left: 10px;
        }
            .print-header {
              text-align: center;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .print-footer {
              position: fixed;
              bottom: 10px;
              left: 0;
              right: 0;
              text-align: center;
              font-size: 12px;
              color: gray;
            }
            .print-footer::after {
              content: "Page " counter(page) " of " counter(pages);
            }
            .no-print {
              display: none !important;
            }
          }
        `;
      
        document.head.appendChild(style); // Add style to the document
      
        setTimeout(() => {
          const printTrigger = document.getElementById('print-button');
          if (printTrigger) (printTrigger as HTMLElement).click();
          
          document.title = ''; // Restore original title after printing
          
          // document.head.removeChild(style); // Remove the style after printing
        }, 500); // Delay ensures styles apply before printing
      }
    //  this. getReportData();

    rep_type:any
    getdatabydep:any
    assignoffwithtype(){
    
      this.rep_type = "issue"
  
      this.service.getListofassignrep(this.rep_type).subscribe((data) => {
        this.getdatabydep = data;
        console.log(this.getdatabydep)
      });
      
    }

    
}
